<div class="modal-header">
    <h5 class="modal-title">Chi Tiết Thành Viên</h5>
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  
  <div class="modal-body">
    <div class="container mt-4">
        <ul class="nav nav-tabs" id="profileTabs" role="tablist">
          <li class="nav-item" role="presentation">
            <a class="nav-link active" id="profile-tab" data-bs-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="true">
              <i class="fas fa-user"></i> Hồ Sơ
            </a>
          </li>
          <li class="nav-item" role="presentation">
            <a class="nav-link" id="account-summary-tab" data-bs-toggle="tab" href="#account-summary" role="tab" aria-controls="account-summary" aria-selected="false">
              <i class="fas fa-list-alt"></i> Tóm Tắt Tài Khoản
            </a>
          </li>
          <li class="nav-item" role="presentation">
            <a class="nav-link" id="fines-tab" data-bs-toggle="tab" href="#fines" role="tab" aria-controls="fines" aria-selected="false">
              <i class="fas fa-money-bill-alt"></i> Phí Phạt
            </a>
          </li>
          <li class="nav-item" role="presentation">
            <a class="nav-link" id="documents-tab" data-bs-toggle="tab" href="#documents" role="tab" aria-controls="documents" aria-selected="false">
              <i class="fas fa-folder"></i> Tài Liệu
            </a>
          </li>
          <li class="nav-item" role="presentation">
            <a class="nav-link" id="borrowing-history-tab" data-bs-toggle="tab" href="#borrowing-history" role="tab" aria-controls="borrowing-history" aria-selected="false">
              <i class="fas fa-history"></i> Lịch Sử Mượn
            </a>
          </li>
          <li class="nav-item" role="presentation">
            <a class="nav-link" id="memebership-tab" data-bs-toggle="tab" href="#membership" role="tab" aria-controls="membership" aria-selected="false">
              <i class="fas fa-credit-card"></i> Thẻ Thành Viên
            </a>
          </li>
        </ul>
    
        <div class="tab-content mt-3" id="profileTabsContent">
          <!-- Profile Tab -->
          <div class="tab-pane fade show active" id="profile" role="tabpanel" aria-labelledby="profile-tab">
            <div class="row">
              <div class="col-md-6">
                <h2>{{ member?.firstName }} {{ member?.surname }}</h2>
                <p><strong>Ngày Sinh:</strong> {{ member?.dob || 'Chưa cung cấp' }}</p>
                <p><strong>Tuổi:</strong> {{ member?.age || 'Chưa cung cấp' }}</p>
                <p><strong>Giới Tính:</strong> {{ member?.gender || 'Chưa cung cấp' }}</p>
                
                <h5>Thông Tin Liên Lạc:</h5>
                <p><strong>Số Điện Thoại Chính:</strong> {{ member?.primaryPhone || 'Chưa cung cấp' }}</p>
                <p><strong>Số Điện Thoại Phụ:</strong> {{ member?.secondaryPhone || 'Chưa cung cấp' }}</p>
                <p><strong>Email Chính:</strong> {{ member?.primaryEmail || 'Chưa cung cấp' }}</p>
                <p><strong>Email Phụ:</strong> {{ member?.secondaryEmail || 'Chưa cung cấp' }}</p>
              </div>
    
              <div class="col-md-6">
                <h5>Địa Chỉ:</h5>
                <p>
                  {{ member?.streetNumber }} {{ member?.address }},<br>
                  {{ member?.city }}, {{ member?.state }}, {{ member?.zip }}, {{ member?.country }}
                </p>
    
                <h5>Thông Tin Phòng Ban:</h5>
                <p><strong>Trưởng Phòng:</strong> {{ member?.headOfDepartment || 'Chưa cung cấp' }}</p>
                
                <h5>Thông Tin Bổ Sung:</h5>
                <p><strong>Loại Người Dùng:</strong> {{ member?.userType }}</p>
                <p><strong>ID Loại:</strong> {{ member?.typeId }}</p>
                <p><strong>Trạng Thái:</strong> {{ member?.status }}</p>
              </div>
            </div>
          </div>

          <div class="tab-pane fade" id="membership" role="tabpanel" aria-labelledby="membership-tab">
            <div class="membership-container">
                <div class="membership-card bg-white">
                    <div class="membership-card-header d-flex align-items-center justify-content-between">
                        <img height="50"  width="50" src="https://icons.veryicon.com/png/o/miscellaneous/user-avatar/user-avatar-male-5.png" alt="Hình Ảnh Thành Viên" class="img-fluid rounded-circle">
                        <h5 class="text-primary">Thẻ Thành Viên</h5>
                    </div>
                    <div class="membership-details">
                      <p><strong>Tên:</strong> {{member.firstname}} {{member.surname}}</p>
                      <p><strong>Ngày Sinh:</strong> {{member.dob}}</p>
                      <p><strong>Tuổi:</strong> {{member.age}}</p>
                      <p><strong>Giới Tính:</strong> {{member.gender}}</p>
                      <p><strong>Địa Chỉ:</strong> {{member.street_number}} {{member.address}}, {{member.city}}, {{member.state}} {{member.zip}}, {{member.country}}</p>
                      <p><strong>Số Điện Thoại Chính:</strong> {{member.primary_phone}}</p>
                      <p><strong>Email:</strong> {{member.primary_email}}</p>
                  </div>
                    <div class="membership-footer text-center text-muted">
                        <p>Powered by Library Lab</p>
                    </div>
                </div>
            </div>

            <div class="text-center mt-3">
                <button class="btn btn-outline-primary" (click)="downloadCard()">Download Card</button>
                <button class="btn btn-outline-secondary" (click)="printCard()">Print Card</button>
              </div>

          </div>
    
          <!-- Account Summary Tab -->
          <div class="tab-pane fade" id="account-summary" role="tabpanel" aria-labelledby="account-summary-tab">
            <h3>Tóm Tắt Tài Khoản</h3>
            <div class="container mt-5">
                <div class="row">
                  <div class="col-md-4 mb-4">
                    <div class="card text-center border">
                      <div class="card-body">
                        <h5 class="card-title text-dark">Tổng Số Sách Đã Mượn</h5>
                        <p class="card-text h4">{{ statistics?.totalBooksBorrowed }}</p>
                      </div>
                    </div>
                  </div>
              
                  <div class="col-md-4 mb-4">
                    <div class="card text-center border">
                      <div class="card-body">
                        <h5 class="card-title text-primary">Sách Đang Mượn</h5>
                        <p class="card-text h4">{{ statistics?.currentlyBorrowedBooks }}</p>
                      </div>
                    </div>
                  </div>
              
                  <div class="col-md-4 mb-4">
                    <div class="card text-center border">
                      <div class="card-body">
                        <h5 class="card-title text-warning">Sách Quá Hạn</h5>
                        <p class="card-text h4">{{ statistics?.overdueBooks }}</p>
                      </div>
                    </div>
                  </div>
              
                  <div class="col-md-4 mb-4">
                    <div class="card text-center border">
                      <div class="card-body">
                        <h5 class="card-title text-info">Tỷ Lệ Mượn Trung Bình</h5>
                        <p class="card-text h4">{{ statistics?.averageBorrowingRate }}</p>
                      </div>
                    </div>
                  </div>
              
                
              
                  <div class="col-md-4 mb-4">
                    <div class="card text-center border">
                      <div class="card-body">
                        <h5 class="card-title text-dark">Sách Được Mượn Nhiều Nhất</h5>
                        <p class="card-text h4">{{ statistics?.mostBorrowedBook }}</p>
                      </div>
                    </div>
                  </div>
              
                
                </div>
              </div>
              
          </div>
    
          <!-- Fines Tab -->
          <div class="tab-pane fade" id="fines" role="tabpanel" aria-labelledby="fines-tab">
            <h3>Phí Phạt</h3>
            <div class="container mt-5">
                <div class="row">
                  <div class="col-md-4 mb-4">
                    <div class="card text-center border">
                      <div class="card-body">
                        <h5 class="card-title text-danger">Tổng Phí Phạt Tích Lũy</h5>
                        <p class="card-text h4">${{ statistics?.totalFinesAccrued }}</p>
                      </div>
                    </div>
                  </div>
              
                  <div class="col-md-4 mb-4">
                    <div class="card text-center border">
                      <div class="card-body">
                        <h5 class="card-title text-success">Tổng Phí Phạt Đã Thanh Toán</h5>
                        <p class="card-text h4">${{ statistics?.totalFinesPaid }}</p>
                      </div>
                    </div>
                  </div>
              
                  <div class="col-md-4 mb-4">
                    <div class="card text-center border">
                      <div class="card-body">
                        <h5 class="card-title text-danger">Phí Phạt Còn Lại</h5>
                        <p class="card-text h4">${{ statistics?.outstandingFines }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

             <!--  <div id="paypal-button-container"></div> -->

             <div class="button-container">
              <button (click)="generatePaymentLink('2.00','USD','paying fees')" class="btn btn-primary">
                <i class="fas fa-link"></i> Tạo Liên Kết Thanh Toán
              </button>
              <button (click)="sendPaymentLink()" class="btn btn-outline-success">
                <i class="fas fa-paper-plane"></i> Gửi Liên Kết Thanh Toán
              </button>
            </div>
            
            <div *ngIf="paymentLink">
              <p><strong>Liên Kết Thanh Toán Đã Tạo:</strong></p>
              <a [href]="paymentLink" target="_blank">{{ paymentLink }}</a>
              <button (click)="copyPaymentLink(paymentLink)" class="btn btn-outline-info">
                <i class="fas fa-copy"></i> Sao Chép Liên Kết
              </button>
            </div>
            
              
          </div>


          <!-- <div class="tab-pane fade" id="notification" role="tabpanel" aria-labelledby="notification-tab">
            <h3>Notifications</h3>
           
          </div>   -->
    
          <!-- Documents Tab -->
          <div class="tab-pane fade" id="documents" role="tabpanel" aria-labelledby="documents-tab">
            <!-- <h3>Documents</h3> -->
           <!--  <form [formGroup]="uploadForm" (ngSubmit)="onSubmit()" enctype="multipart/form-data">
                <input type="file" formControlName="file" (change)="onFileChange($event)" />
                <button type="submit">Upload File</button>
              </form> -->

              <div class="container mt-5">
                <h4 class="mb-4">Documents</h4>
                <div class="list-group">
                    <div class="list-group-item" *ngFor="let document of files">
                        <div class="d-flex justify-content-between align-items-center">
                            <span>{{ document.filename }}</span>
                            <button 
                                class="btn btn-outline-primary" 
                                (click)="downloadFile(document.filename)">
                                <i class="fas fa-download me-1"></i> Download
                            </button>
                        </div>
                    </div>
                </div>
            </div>
              
          </div>
    
          <!-- Borrowing History Tab -->
          <div class="tab-pane fade" id="borrowing-history" role="tabpanel" aria-labelledby="borrowing-history-tab">
            <h3>Borrowing History</h3>
            <ngx-datatable
        class="bootstrap"
        [rows]="circulations"
        [columnMode]="'force'"
        [headerHeight]="50"
        [footerHeight]="50"
        [rowHeight]="'auto'"
        [loadingIndicator]="loadingIndicator"
        [reorderable]="reorderable"
      >
        <!-- <ngx-datatable-column name="ID" prop="id"></ngx-datatable-column> -->
        <!-- <ngx-datatable-column name="Member Name" prop="memberName.firstname"></ngx-datatable-column> -->
      <ngx-datatable-column name="Book Name" prop="catalogItemName.title"></ngx-datatable-column>
        <ngx-datatable-column name="Issue Date" prop="issueDate"></ngx-datatable-column>
        <ngx-datatable-column name="Last Date" prop="lastDate"></ngx-datatable-column>
        <ngx-datatable-column name="To Return" prop="toReturn"></ngx-datatable-column>
        <ngx-datatable-column name="Return Date" prop="returnDate"></ngx-datatable-column>
       <!--  <ngx-datatable-column name="Penalty" prop="penalty"></ngx-datatable-column> -->
        <ngx-datatable-column name="Return Status" prop="returnStatus.name"></ngx-datatable-column>
      </ngx-datatable>
          </div>
        </div>
      </div>
  </div>
  
  <div class="modal-footer">
    <div class="button-group">      
      <button type="button" class="btn btn-outline-secondary" (click)="closeModal()">
        <i class="fas fa-times"></i> Close
      </button>
    </div>
  </div>


